import { render, staticRenderFns } from "./WxCodeLogin.vue?vue&type=template&id=2f799eda&scoped=true"
import script from "./WxCodeLogin.vue?vue&type=script&lang=js"
export * from "./WxCodeLogin.vue?vue&type=script&lang=js"
import style0 from "./WxCodeLogin.vue?vue&type=style&index=0&id=2f799eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f799eda",
  null
  
)

export default component.exports